import { useState, useEffect, useCallback } from "react";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import CustomModal from "../components/CustomModal";
import { toast } from "react-toastify";

function ManageSignUp() {
  const [showModal, setShowModal] = useState(false);
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editLoading, setEditLoading] = useState(false);
  const [editForm, setEditForm] = useState({
    name: "",
    email: "",
    role_selected: "",
    hours_selected: "",
    skills: "",
    confirm_availability: false,
    agree_training: false,
  });

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const openModal = (opportunity) => {
    setSelectedOpportunity(opportunity);
    setEditForm({
      name: opportunity.name || "",
      email: opportunity.email || "",
      role_selected: opportunity.role_selected || "",
      hours_selected: opportunity.hours_selected || "",
      skills: opportunity.skills || "",
      confirm_availability: opportunity.confirm_availability === 1 || false,
      agree_training: opportunity.agree_training === 1 || false,
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedOpportunity(null);
    setEditForm({
      name: "",
      email: "",
      role_selected: "",
      hours_selected: "",
      skills: "",
      confirm_availability: false,
      agree_training: false,
    });
  };

  const confirmCancelSignup = (opportunity) => {
    setSelectedOpportunity(opportunity);
    setShowCancelModal(true);
  };

  const handleDoThisLater = () => setShowCancelModal(false);
  const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;

  const handleCancelSignup = async () => {
    if (!selectedOpportunity) return;

    try {
      const token = localStorage.getItem("authToken");
      const opportunityId =
        selectedOpportunity.opportunity_id ||
        selectedOpportunity.volunteer_opportunity_id ||
        selectedOpportunity.volunteerOpportunityId ||
        selectedOpportunity.opportunityId;

      const signupId = selectedOpportunity.id;

      if (!opportunityId) {
        console.error(
          " opportunity_id is missing. Available fields:",
          Object.keys(selectedOpportunity)
        );
        return toast.error(
          "Cannot find opportunity ID. Please refresh and try again."
        );
      }

      const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;

      const response = await fetch(
        `${TEST_BASE_URL}/volunteer-opportunities/${opportunityId}/signups/${signupId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      if (response.ok) {
        toast.success("Signup cancelled successfully!");
        setShowCancelModal(false);
        setOpportunities(
          opportunities.filter((op) => op.id !== selectedOpportunity.id)
        );
      } else {
        toast.error("Failed to cancel signup. Please try again.");
      }
    } catch (err) {
      console.error("Cancel error:", err);
      toast.error("Error cancelling signup.");
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    if (!editForm.confirm_availability || !editForm.agree_training) {
      return toast.error("You must agree to all conditions.");
    }

    if (!editForm.role_selected || !editForm.hours_selected) {
      return toast.error("Please select a role and available hours.");
    }

    try {
      setEditLoading(true);
      const token = localStorage.getItem("authToken");
      const opportunityId =
        selectedOpportunity.opportunity_id ||
        selectedOpportunity.volunteer_opportunity_id ||
        selectedOpportunity.volunteerOpportunityId ||
        selectedOpportunity.opportunityId;

      const signupId = selectedOpportunity.id;


      if (!opportunityId) {
        console.error(
          " opportunity_id is missing. Available fields:",
          Object.keys(selectedOpportunity)
        );
        return toast.error(
          "Cannot find opportunity ID. Please refresh and try again."
        );
      }

      const payload = {
        name: editForm.name,
        email: editForm.email,
        role_selected: editForm.role_selected,
        hours_selected: editForm.hours_selected,
        skills: editForm.skills || "",
        confirm_availability: editForm.confirm_availability ? 1 : 0,
        agree_training: editForm.agree_training ? 1 : 0,
      };

      const response = await fetch(
        `${TEST_BASE_URL}/volunteer-opportunities/${opportunityId}/signups/${signupId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );



      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.error("Invalid JSON response:", text);
        data = { message: "Invalid server response" };
      }

     

      if (!response.ok) {
        const errorMsg =
          data?.errors && typeof data.errors === "object"
            ? Object.values(data.errors).flat().join(" ")
            : data?.message || "Update failed. Please try again.";

        console.error(" Error:", errorMsg);
        return toast.error(errorMsg);
      }

      toast.success("Signup updated successfully!");
      closeModal();
      fetchOpportunities();
    } catch (err) {
      console.error(" Update error:", err);
      toast.error("Failed to update signup. Please try again.");
    } finally {
      setEditLoading(false);
    }
  };

  const handleEditFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const fetchOpportunities = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        setError("You are not authenticated.");
        return;
      }

      const response = await fetch(
        `${TEST_BASE_URL}/user-volunteer-opportunities`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const text = await response.text();
      let result;

      try {
        result = JSON.parse(text);
      } catch {
        console.warn(
          "Server returned HTML instead of JSON:",
          text.slice(0, 200)
        );
        throw new Error("Invalid server response.");
      }

      if (!response.ok) {
        throw new Error(result.message || "Failed to fetch user signups.");
      }

      const list = Array.isArray(result.data) ? result.data : [];
      setOpportunities(list);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [TEST_BASE_URL]);

  useEffect(() => {
    fetchOpportunities();
  }, [fetchOpportunities]);

  const personIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 84 92"
      fill="none"
    >
      <path
        d="M73.875 18.375L71.2412 60.9816C70.5682 71.8674 70.2318 77.3103 67.5032 81.2234C66.1542 83.1581 64.4173 84.791 62.403 86.0181C58.329 88.5 52.8757 88.5 41.9692 88.5C31.0482 88.5 25.5878 88.5 21.511 86.0135C19.4954 84.7841 17.758 83.1484 16.4094 81.2106C13.6817 77.291 13.3527 71.8405 12.6946 60.9394L10.125 18.375"
        stroke="white"
        strokeWidth="6.375"
        strokeLinecap="round"
      />
      <path
        d="M3.75 18.375H80.25M59.2368 18.375L56.3355 12.3898C54.4082 8.41409 53.4446 6.42622 51.7823 5.18642C51.4136 4.91142 51.0231 4.66681 50.6148 4.45498C48.7741 3.5 46.565 3.5 42.1467 3.5C37.6175 3.5 35.3529 3.5 33.4817 4.49501C33.0669 4.71553 32.6712 4.97006 32.2985 5.25596C30.617 6.54598 29.6777 8.6066 27.7991 12.7278L25.2249 18.375"
        stroke="white"
        strokeWidth="6.375"
        strokeLinecap="round"
      />
      <path
        d="M31.375 65.125L31.375 39.625"
        stroke="white"
        strokeWidth="6.375"
        strokeLinecap="round"
      />
      <path
        d="M52.625 65.125L52.625 39.625"
        stroke="white"
        strokeWidth="6.375"
        strokeLinecap="round"
      />
    </svg>
  );

  return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content">
        <TopBar onToggleSidebar={toggleSidebar} />

        <div
          className={`bottom-content ${
            loading || opportunities.length === 0 ? "full-height" : "fit-height"
          }`}
        >
          <div className="prayer-title">
            <span>Volunteering</span>
          </div>

          <div className="volunteer-head">
            <span className="fs-5">My Volunteer Signups</span>
          </div>

          {loading && <p>Loading your signups...</p>}
          {error && <p className="text-danger">Error: {error}</p>}

          <div className="row mt-4">
            {opportunities.length > 0
              ? opportunities.map((op) => (
                  <div className="col-md-4 mb-4" key={op.id}>
                    <div className="volunteer-signup-card">
                      <div>Signed Up</div>
                      <h6>{op.opportunity?.title || "Untitled Opportunity"}</h6>

                      <span>
                        <b>Roles Needed:</b>{" "}
                        {op.opportunity?.roles_needed || "N/A"}
                      </span>

                      <span>
                        <b>Special Requirements:</b>{" "}
                        {op.opportunity?.special_requirements || "None"}
                      </span>

                      <div>
                        {op.hours_selected
                          ? op.hours_selected
                          : "Hours not specified"}
                      </div>

                      <div className="volunteer-signup-button">
                        <button onClick={() => openModal(op)}>Edit</button>
                        <button onClick={() => confirmCancelSignup(op)}>
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              : !loading && <p>No volunteer signups found.</p>}
          </div>
        </div>
      </div>

      {showModal && (
        <div className="rsvp-backdrop">
          <div className="rsvp-box">
            <h4 className="pb-1">Edit Sign Up</h4>
            <h6>
              {selectedOpportunity
                ? selectedOpportunity.title
                : "Volunteer Signup"}
            </h6>

            <form onSubmit={handleEditSubmit}>
              <label>Confirm name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={editForm.name}
                onChange={handleEditFormChange}
                placeholder="Enter your name"
              />

              <label>Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={editForm.email}
                onChange={handleEditFormChange}
                placeholder="Enter email"
              />

              <label>Select volunteer roles</label>
              <select
                name="role_selected"
                className="selectroles form-control"
                value={editForm.role_selected}
                onChange={handleEditFormChange}
              >
                <option value="">Select Available Roles</option>
                <option value="Chorister">Chorister</option>
                <option value="Media">Media</option>
                <option value="Protocol">Protocol</option>
                <option value="Welfare">Welfare</option>
                <option value="Logistics">Logistics</option>
              </select>

              <label>Choose available hours</label>
              <select
                name="hours_selected"
                className="selectroles form-control"
                value={editForm.hours_selected}
                onChange={handleEditFormChange}
              >
                <option value="">Choose Hours</option>
                <option value="Morning">Morning</option>
                <option value="Afternoon">Afternoon</option>
                <option value="Evening">Evening</option>
              </select>

              <label>Do you have any relevant skills or experience?</label>
              <textarea
                name="skills"
                rows="5"
                placeholder="Enter relevant skills"
                className="form-control"
                value={editForm.skills}
                onChange={handleEditFormChange}
              ></textarea>

              <div className="confirm">
                <input
                  type="checkbox"
                  name="confirm_availability"
                  id="agreement1"
                  checked={editForm.confirm_availability}
                  onChange={handleEditFormChange}
                />
                <label htmlFor="agreement1">
                  I confirm my availability and willingness to serve for this
                  opportunity.
                </label>
              </div>

              <div className="confirm">
                <input
                  type="checkbox"
                  name="agree_training"
                  id="agreement2"
                  checked={editForm.agree_training}
                  onChange={handleEditFormChange}
                />
                <label htmlFor="agreement2">
                  I agree to attend any necessary briefings or training related
                  to this role.
                </label>
              </div>

              <div className="modalbutton">
                <button
                  type="button"
                  onClick={closeModal}
                  disabled={editLoading}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="text-white"
                  disabled={editLoading}
                >
                  {editLoading ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <CustomModal
        isOpen={showCancelModal}
        title="Cancel Signup?"
        message="Clear this volunteer signup - this action cannot be undone."
        secondaryText="Keep It"
        primaryText="Yes, Cancel"
        onPrimary={handleCancelSignup}
        onSecondary={handleDoThisLater}
        icon={personIcon}
      />
    </section>
  );
}

export default ManageSignUp;
